import {IUserProfile} from '@wholesalechange/chatcomponent';
import {IOnboardingProfileFields, ISiteSettings} from '../../redux/auth/interfaces';

export const isOnboardingPending = (
  settings: ISiteSettings | null,
  userProfile: (IUserProfile & IOnboardingProfileFields) | null
): boolean => Boolean(settings?.onboarding) && Boolean(userProfile) && !userProfile?.onboarding;
